import { TAPIClient } from '../client';

type TStatusResponse = {
  status: string;
};

type TSystemClient = {
  status(): Promise<TStatusResponse | undefined>;
  time(): Promise<{ time: string } | undefined>;
};

function SystemClient(apiClient: TAPIClient): TSystemClient {
  return {
    async status(): Promise<TStatusResponse | undefined> {
      return apiClient.get<TStatusResponse>(`/system/status`);
    },

    async time(): Promise<{ time: string } | undefined> {
      return apiClient.get<{ time: string }>(`/system/time`);
    },
  };
}

export { TSystemClient, SystemClient };
